import { useCallback, useEffect, useRef } from "react";
import { useHistory } from "react-router";

interface UseRedirectToCreatedInstanceOptions {
  environmentId?: string;
  organizationId?: string;
}

export function useRedirectToCreatedInstance({
  environmentId,
  organizationId,
}: UseRedirectToCreatedInstanceOptions) {
  const history = useHistory();
  const environmentIdBeforeDeployment = useRef<string | null>(null);
  const isWaitingForEnvironment = useRef(false);

  useEffect(() => {
    if (
      !isWaitingForEnvironment.current ||
      !environmentId ||
      environmentId === environmentIdBeforeDeployment.current ||
      !organizationId
    ) {
      return;
    }

    isWaitingForEnvironment.current = false;
    history.push(
      `/org/${organizationId}/environments/${environmentId}#Container`,
    );
  }, [environmentId, history, organizationId]);

  const beginRedirect = useCallback(() => {
    environmentIdBeforeDeployment.current = environmentId ?? null;
    isWaitingForEnvironment.current = true;
  }, [environmentId]);

  const cancelRedirect = useCallback(() => {
    isWaitingForEnvironment.current = false;
    environmentIdBeforeDeployment.current = null;
  }, []);

  return { beginRedirect, cancelRedirect };
}
